import React, { useState, useEffect } from 'react';
import { Post } from 'API';

import { getUser } from 'API';

function Login({ user }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);


    const bodyFormData = new FormData();
    bodyFormData.append('username', username);
    bodyFormData.append('password', password);


    try {
      const response = await Post('/auth/login/password', { username, password });
      
      const user = response.data;

      if (!user || !user.paxId) throw 'Error logging in';

      window.location.replace(`/app/pax?pax=${user.paxId}`);
    } catch (err) {
      try {
        const user = await getUser();
        if (!user || !user.paxId) throw 'Error logging in';

        window.location.replace(`/app/pax?pax=${user.paxId}`);
      } catch (error) {
        setError(err.response?.data?.message || 'Login failed. Please try again.');
        console.error('Login error:', err); 
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && user.paxId) {
      window.location.replace(`/app/pax?pax=${user.paxId}`);
    }
  }, [user]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      padding: '20px'
    }}>
      <form onSubmit={handleSubmit} style={{
        width: '100%',
        maxWidth: '400px',
        padding: '30px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '20px', textAlign: 'center' }}>Login</h2>
        
        {error && (
          <div style={{
            padding: '10px',
            marginBottom: '15px',
            backgroundColor: '#fee',
            color: '#c33',
            borderRadius: '4px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '15px' }}>
          <label htmlFor="username" style={{ 
            display: 'block', 
            marginBottom: '5px',
            fontWeight: '500'
          }}>
            Username
          </label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={loading}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="password" style={{ 
            display: 'block', 
            marginBottom: '5px',
            fontWeight: '500'
          }}>
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: loading ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontWeight: '500'
          }}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
}

export default Login;
